import { AppRouteRecordRaw } from '../types';

const Body = () => import('@/components/body.vue');
const NetworkAndIpAllowlist = () =>
  import('@/pages/security-and-compliance/network-and-ip-allowlist/NetworkAndIpAllowlist.vue');
const HostingAndInfrastructure = () =>
  import('@/pages/security-and-compliance/hosting-and-infrastructure/HostingAndInfrastructure.vue');
const ServiceProviders = () =>
  import('@/pages/security-and-compliance/service-providers/ServiceProviders.vue');
const DataProtection = () =>
  import('@/pages/security-and-compliance/data-protection/DataProtection.vue');

/**
 * Security & Compliance (ticket 2026-10-19-security-and-compliance-section): one page per topic,
 * each in its own folder under `src/pages/security-and-compliance/`. No route-level partner gate:
 * the sidebar hides the section from fleet-only partners without the
 * `securityAndComplianceEnabled` flag, but the content is not confidential (D-06).
 */
export const securityAndComplianceRoutes: AppRouteRecordRaw[] = [
  {
    path: '/security-and-compliance',
    component: Body,
    meta: {
      breadcrumb: 'Security & Compliance',
    },
    children: [
      { path: '', redirect: '/security-and-compliance/network-and-ip-allowlist' },
      {
        path: 'network-and-ip-allowlist',
        // Hero metadata is keyed by route name (pages/security-and-compliance/components/doc-meta.ts).
        name: 'NetworkAndIpAllowlist',
        component: NetworkAndIpAllowlist,
        meta: {
          title: 'Network & IP Allowlist | ryd Portal',
          breadcrumb: 'Network & IP Allowlist',
        },
      },
      {
        path: 'hosting-and-infrastructure',
        name: 'HostingAndInfrastructure',
        component: HostingAndInfrastructure,
        meta: {
          title: 'Hosting & Infrastructure | ryd Portal',
          breadcrumb: 'Hosting & Infrastructure',
        },
      },
      {
        path: 'service-providers',
        name: 'ServiceProviders',
        component: ServiceProviders,
        meta: {
          title: 'Service Providers | ryd Portal',
          breadcrumb: 'Service Providers',
        },
      },
      {
        path: 'data-protection',
        name: 'DataProtection',
        component: DataProtection,
        meta: {
          title: 'Data Protection & GDPR | ryd Portal',
          breadcrumb: 'Data Protection & GDPR',
        },
      },
    ],
  },
];
